
export const imgStyleComp={
  width:'150px',
  margin:'25px auto 40px'
}


export const matCard= {
  paddingTop: '5rem',
  paddingBottom: '5rem',
  margin:'2em 5em'
}

export const matCardContent= {
  fontSize: '1.5rem',
  color: '#333b46',
  fontWeight:'500'
}


export const matCardActions={
  display: 'flex',
  justifyContent: 'space-evenly',
  marginTop:'1em'
}

export const matCardActions2={
  display: 'flex',
  justifyContent: 'center',
  marginTop:'1em'
}

export const flexBasis30={
  flexBasis: '30%',
  fontSize:'14px',
  textTransform:'none',
  fontWeight:'600'
  // color:'white'
}

export const flexBasis25={
  flex: '0 0 25%',
  fontSize:'14px',
  textTransform:'none',
  fontWeight:'600'
  // color:'white'
}

export const submitBtn={
  fontSize:'14px',
  fontWeight:'bold',
  textTransform:'none'
  // color:'white'
}

export const correctWrongBtn={
  fontSize: '3rem',
   margin: '2rem',
   textTransform:'none'
}

export const Hr={
  borderTop: '1px solid #ccc'
}